var _a;
import { __decorate, __metadata, __param } from "tslib";
import { UserService } from '@/domains/user/services/user-service.interface';
import { injectable, inject } from '@/inversify.config';
import { updateGuideOnceLogApi, getGuideOnceLogApi } from '@cores/apis/others_api/core_basic';
import _ from 'lodash';
let GuideService = class GuideService {
    constructor(userService) {
        this.userService = userService;
        this.guide = {};
    }
    get isSpecialIp() {
        return this.userService.userInfo.special_ip;
    }
    get uuid() {
        return this.userService.userInfo.encrypted_account_id;
    }
    getGuideKey({ key, type }) {
        // this.init();
        if (this.isSpecialIp) {
            return Promise.resolve(localStorage.getItem(key));
        }
        const value = localStorage.getItem(`${key}_${this.uuid}`);
        if (value)
            return Promise.resolve(value);
        if (this.guide[key])
            return Promise.resolve(this.guide[key]);
        return getGuideOnceLogApi(type).then(res => {
            const guideData = _.get(res, 'tips', {});
            this.guide = guideData;
            if (guideData[key]) {
                localStorage.setItem(`${key}_${this.uuid}`, guideData[key]);
            }
            return guideData[key];
        });
    }
    /**
     * @param {String} key
     * @param {any} value  可以是任何值
     * @param {String} type  表示当前的产品模块。
     * @param {boolean} this.isSpecialIp 是否是特殊ip
     */
    updateGuideKey({ key, value, type }) {
        if (this.isSpecialIp) {
            localStorage.setItem(key, value);
            return Promise.resolve();
        }
        return updateGuideOnceLogApi({
            key,
            value,
            module_type: type,
        }).then(() => {
            this.guide[key] = value;
            localStorage.setItem(`${key}_${this.uuid}`, value);
        });
    }
};
GuideService = __decorate([
    injectable(),
    __param(0, inject(UserService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserService !== "undefined" && UserService) === "function" ? _a : Object])
], GuideService);
export { GuideService };
